let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hHK1O")).then(() => parcelRequire('dPOXA'));